import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIfoodComponent } from './simple-icons-ifood.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIfoodComponent ],
    exports:      [ SimpleIconsIfoodComponent ],
    bootstrap:    []
})
export class SimpleIconsIfoodModule {}
